// styles 
import './Project.css'
import { projectStore } from '../../store/Store'

const filterList = ['all', 'missing ticket', 'customer not invoiced', 'vendor freight not invoiced', 'vendor sand not invoiced', 'locked', 'duplicate bols', 'transfers', 'review', 'ticket mismatch']
const assetFilters = ['all', 'customer not invoiced', 'freight not invoiced', 'locked']
const assetFiltersNoCInvoice = ['all', 'freight not invoiced', 'locked']
const assetFiltersNoVInvoice = ['all', 'customer not invoiced', 'locked']

export default function LoadsFilter({setLoadsFilter, isAsset, setFilterOptions, setLoadsSearch, currFilter, setCurrFilter}) {
  // global
  const projectLoads = projectStore(data => data.projectLoads)
  const projectAssetLoads = projectStore(data => data.projectAssetLoads)
  const projectTotals = projectStore(data => data.projectTotals)
  const currentProject = projectStore(data => data.currentProject)
  
  // local
  
  const avg_weight = projectTotals.project_totals.average_weight_tons
  
  const handleClick = (newFilter) => {
    setCurrFilter(newFilter)
    if (isAsset) {
      setFilterOptions({
        load: '',
        carrier: '',
        customer_invoice: '',
        approval_status: '',
      })
    } else {
      setFilterOptions({
        load: '',
        carrier: '',
        terminal: '',
        customer_invoice: '',
        approval_status: '',
      })
    }
    setLoadsSearch([])
    let vis=[]
    if (!isAsset) {
      switch (newFilter) {
        case 'all':
          vis = projectLoads
          break
        case 'missing ticket':
          projectLoads.forEach(l => {
            if (l.ticket_is_missing && l.transfer_type_id !== 12) {
              vis.push(l)
            }
          })
          break
        case 'customer not invoiced':
          projectLoads.forEach(l => {
            if (l.customer_invoice_id === 0 && l.transfer_type_id !== 12 && (!l.is_pass_through || l.sand_rev > 0)) {
              vis.push(l)
            }
          })
          break
        case 'vendor freight not invoiced':
          projectLoads.forEach(l => {
            if (l.vendor_invoice_id === 0 && l.transfer_type_id !== 12 && !l.is_pass_through) {
              vis.push(l)
            }
          })
          break
        case 'vendor sand not invoiced':
            projectLoads.forEach(l => {
              if (l.sand_invoice_id === 0 && l.sand_cost > 0 && l.transfer_type_id !== 12) {
                vis.push(l)
              }
            })
          break
        case 'locked':
          projectLoads.forEach(l => {
            if (l.locked_reason !=="" && l.transfer_type_id !== 12) {
              vis.push(l)
            }
          })
          break
        case 'duplicate bols':
          projectLoads.forEach(l => {
            if (l.matching_load_numbers.length !==1 && l.transfer_type_id !== 12) {
              vis.push(l)
            }
          })
          break
        case 'transfers':
          projectLoads.forEach(l => {
            if (l.tranferred_project_id !== "") {
              vis.push(l)
            }
          })
          break
          
        case 'review':
          projectLoads.forEach(l => {
            if ((l.approved_mileage <= 0 || l.weight_tons > avg_weight + avg_weight*.1 || l.weight_tons < avg_weight - avg_weight*.1) && l.transfer_type_id !== 12) {
              vis.push(l)
            }
          })
          break
        case 'ticket mismatch':
          projectLoads.forEach(l => {
            if ((l.driver_ticket_auto_status_name === 'Ticket Mismatch' || l.driver_ticket_auto_status_name === "Ticket Pending OCR") && l.transfer_type_id !== 12) {
              vis.push(l)
            }
          })
          break
        default:
          break
      }
    } else {
      switch (newFilter) {
        case 'all':
          vis = projectAssetLoads
          break
        case 'customer not invoiced':
          projectAssetLoads.forEach(l => {
            if (l.customer_invoice_id === 0 && !l.is_pass_through) {
              vis.push(l)
            }
          })
          break
        case 'freight not invoiced':
          projectAssetLoads.forEach(l => {
            if (l.vendor_invoice_id === 0 && !l.is_pass_through) {
              vis.push(l)
            }
          })
          break
        case 'locked':
          projectAssetLoads.forEach(l => {
            if (l.locked_reason !=="") {
              vis.push(l)
            }
          })
          break
        default:
          break
      }
    }
    
    setLoadsFilter(vis)
  }
  
  return (
    <div className='filter'>
      <nav>
        {!isAsset ? filterList.map(f => (
          <button 
            key={f}
            className={currFilter === f ? 'active' : ''}
            onClick={() => handleClick(f)}
          >
            {f}
          </button>
        )) : (currentProject.project.fixed_mob_rev === 0 && currentProject.project.fixed_mob_cost === 0 && isAsset) ?
        assetFilters.map(f => (
          <button 
            key={f}
            className={currFilter === f ? 'active' : ''}
            onClick={() => handleClick(f)}
          >
            {f}
          </button>
        )) : 
        (currentProject.project.fixed_mob_rev > 0 && currentProject.project.fixed_mob_cost === 0 && isAsset) ?
        assetFiltersNoCInvoice.map(f => (
          <button 
            key={f}
            className={currFilter === f ? 'active' : ''}
            onClick={() => handleClick(f)}
          >
            {f}
          </button>
        )) : (currentProject.project.fixed_mob_rev === 0 && currentProject.project.fixed_mob_cost > 0 && isAsset) &&
        assetFiltersNoVInvoice.map(f => (
          <button 
            key={f}
            className={currFilter === f ? 'active' : ''}
            onClick={() => handleClick(f)}
          >
            {f}
          </button>
        ))}
      </nav>
    </div>
  )
}
